import { PricesResendManager } from "..";
import { HandleErrorResendingArgs } from "./types";
import { manageErrorReSendingValues } from "./manageErrorReSendingValues";

export const handleErrorResending = ({
  errorData,
  row,
  currentErrorSentYields = [],
  statusCodes,
  errorsThatCantBeSent,
}: HandleErrorResendingArgs) => {
  manageErrorReSendingValues({
    currentErrorSentYields,
    errorData: errorData.security,
    row,
    statusCodes,
    errorsThatCantBeSent,
  });

  PricesResendManager.getInstance().popErrorsList();
};
